module.exports = __webpack_public_path__ + "img/presidenza-della-repubblica-no-bg.6dce00a4.png";